import React, { useEffect, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import dayjs from 'dayjs';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';
import GlobalSelectFieldWithoutFormik from '../../../../components/mui/GlobalSelectFieldWithoutFormik';
import { Stack } from '@mui/material';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import { useSearchParams } from 'react-router-dom';
import { tutorDetailsTableHeader, tutorStatus } from './utils/tutorDetailsPageHelper';
import { useDispatch } from 'react-redux';
import { getTutorDetails } from '../../../../redux/features/dashboardSlice';
import { useSelector } from 'react-redux';

export default function TutorDetails() {
  const [searchParams, setSearchParams] = useSearchParams();

  const queryFromDate = searchParams.get('fromDate');
  const queryToDate = searchParams.get('toDate');
  const queryName = searchParams.get('name');

  const dispatch = useDispatch();

  const [filters, setFilters] = useState({
    fromDate: dayjs().startOf('month'),
    toDate: dayjs().endOf('month'),
    status: { id: -1, value: '' },
  });
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: '' },
    frozenColumns: [],
    hiddenColumns: [],
  });

  const tutorDetailsLoading = useSelector((state) => state.dashboard.tutorsDetails.loading);
  const tutorDetailsData = useSelector((state) => state.dashboard.tutorsDetails.data);
  const tutorDetailsMeta = useSelector((state) => state.dashboard.tutorsDetails.meta);

  const filterHelper = (value, key) => {
    if (!value || !key) return;
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    const params = {
      search: tableState?.search,
      startDate: filters.fromDate,
      endDate: filters.toDate,
      page: tableState.page,
      limit: tableState.pageSize,
      status: filters?.status?.id === -1 ? '' : filters.status?.id,
      sortBy: tableState.sort.field,
      sortDirection: tableState.sort.direction,
    };
    dispatch(getTutorDetails(params));
  }, [filters, tableState.search, tableState.page, tableState.pageSize, dispatch, tableState.sort]);

  useEffect(() => {
    if (queryName === 'Total Tutors') {
      filterHelper({ id: -1, value: '' }, 'status');
    } else if (queryName === 'Active Tutors') {
      filterHelper({ id: 'active', value: '' }, 'status');
    }
    filterHelper(dayjs(queryFromDate, 'YYYY-MM-DD').format('YYYY-MM-DD'), 'fromDate');
    filterHelper(dayjs(queryToDate, 'YYYY-MM-DD').format('YYYY-MM-DD'), 'toDate');
  }, [queryName, queryFromDate, queryToDate]);

  return (
    <GlobalWrapper title={'Tutor Details'}>
      <Stack direction={{ xs: 'column', sm: 'row' }} gap={1} mb={1}>
        <FromAndToDatePicker
          fromDate={filters.fromDate}
          toDate={filters.toDate}
          setFromDate={(v) => filterHelper(dayjs(v).format('YYYY-MM-DD'), 'fromDate')}
          setToDate={(v) => filterHelper(dayjs(v).format('YYYY-MM-DD'), 'toDate')}
          fullWidth
        />
        <GlobalSelectFieldWithoutFormik
          sx={{ width: { xs: '100%', sm: 200 } }}
          keys={{ itemId: 'id', itemValue: 'name' }}
          label={'Status'}
          data={tutorStatus}
          setDirectChange={(v) => filterHelper(v, 'status')}
          selectedDetails={filters['status']}
        />
      </Stack>
      <GlobalTable
        rowUniqueId="trainer_id"
        headers={tutorDetailsTableHeader}
        rows={tutorDetailsData}
        loading={tutorDetailsLoading}
        tableState={tableState}
        setTableState={setTableState}
        meta={tutorDetailsMeta}
      />
    </GlobalWrapper>
  );
}
